import { Component } from '@angular/core';
import { DataService } from '../services/data.service';
import { MessageService } from 'primeng/api';
import { AuthService } from '@auth0/auth0-angular';
import { Router } from '@angular/router';
import { SwUpdate, SwPush } from '@angular/service-worker';

@Component({
  selector: 'app-config',
  templateUrl: './config.component.html',
  styleUrls: ['./config.component.css']
})
export class ConfigComponent {

  /*
  currentUser: any;

  users: any[];
  selectedUsers: any[];
  usersLoading: boolean = true;

  strains: any[];
  selectedStrains: any[];
  strainsLoading: boolean = true;*/

  config: any;
  readonly VAPID_PUBLIC_KEY = "BDwt5Hlaopg8-5u1FXK_6F6AAmd5pHuw3ZWwA-VbYwW6SK_Z6hrg_StC0HHo3Rw86hTf9to2iT9uKPK2zQc8Hw8";

  selectedStartDate: Date;
  selectedEndDate: Date;
  usePastWeek: boolean = false;
  isoAlerts: boolean = false;
  newIncidents: boolean = false;
  updatedIncidents: boolean = false;
  plateCompletions: boolean = false;
  instrumentLowCount: boolean = false;
  instrumentInService: boolean = false;
  instrumentOutOfService: boolean = false;
  splitCjunEnabled: boolean = false;
  splitCjunHours: number;
  splitCjunCT: number;
  splitCjunAmount: number;
  graphDays: number;
  isSubscribed: boolean = false;
  platesToMonitor: string;
  sensors: any[] = [];

  //days: number = 30;
  
  constructor(private dataService: DataService,
    private messageService: MessageService,
    private router: Router,
    public auth: AuthService,
    private swPush: SwPush) { }

  ngOnInit() {
    this.getSensors();
    this.checkIsSubscribed();
    this.dataService.getConfig().then(data => {
      this.config = data;
      /*this.dataService.getUsers().then(data => {
        this.users = data.map((s: { key: any; value: any; }) => ({key: s.key, name: s.value}));
        if (this.config !=null && this.config.selectedUsers != null)
          this.selectedUsers = this.users.filter(x =>  this.config.selectedUsers.includes(x.key));
        this.usersLoading = false;
      });

      this.dataService.getStrains().then(data => {
        this.strains = data.map((s: { key: any; value: any; }) => ({key: s.key, name: s.value}));
        if (this.config != null && this.config.selectedStrains != null)
          this.selectedStrains = this.strains.filter(x => this.config.selectedStrains.includes(x.key));
        this.strainsLoading = false;
      });*/

      if (this.config != null)
      {
        if (this.config.selectedStartDate != null)
          this.selectedStartDate = new Date(this.config.selectedStartDate);
        if (this.config.selectedEndDate != null)
          this.selectedEndDate = new Date(this.config.selectedEndDate);
        if (this.config.usePastWeek != null)
          this.usePastWeek = Boolean(this.config.usePastWeek);
        if (this.config.graphDays != null)
          this.graphDays = this.config.graphDays;
      }
    });
  }

  save($event:any) {
    //var userKeys = this.selectedUsers != null ? this.selectedUsers.map(x => x.key).toString() : null;
    //var strainKeys = this.selectedStrains != null ? this.selectedStrains.map(x => x.key).toString() : null;
    this.config = {
      "selectedStartDate": this.selectedStartDate,
      "selectedEndDate": this.selectedEndDate,
      "usePastWeek": this.usePastWeek,
      "graphDays": this.graphDays
    };

    console.log(JSON.stringify(this.config));
    this.dataService.updateConfig(this.config)
      .then(data => {
        this.messageService.add({severity:'success', summary:'Config saved'});
    });
  }

  checkIsSubscribed(){
    this.dataService.isSubValid()
    .then(data => {
      this.isSubscribed = Notification.permission === 'granted' && data
    });
    return Notification.permission === 'granted'
  }
  
  subscribeToNotifications() {
    console.log(Notification.permission);
    if(Notification.permission === 'default') {
      Notification.requestPermission().then(() => {
        this.requestSubscription();
      }).catch(() => {
        console.log("Permission denied implicitly");
        this.messageService.add({severity:'error', summary:'Permission denied implicitly, please check browser settings.'});
      });
    }
    else if(Notification.permission === 'denied') {
      console.log("Permission denied explicitly");
      this.messageService.add({severity:'error', summary:'Permission denied explicitly, please check browser settings.'});
    } else {
      this.requestSubscription();
    }
  }

  async requestSubscription(){
    try {
      const sub = await this.swPush.requestSubscription({ serverPublicKey: this.VAPID_PUBLIC_KEY });
      this.dataService.updateNotificationKeys(sub);
      console.log("subscription object ", sub);
      this.messageService.add({severity:'success', summary:'Subscription updated!'});
      this.isSubscribed = true;

    } catch  (e) {
      console.log("Couldn't get subscription");
      this.messageService.add({severity:'error', summary:'Couldn\'t update subscription.'});
    }
  }

  getSensors(){
    this.sensors.push({
      id: 1,
      name: "test sensor",
      notifEnabled: true
    });
  }
}
